/**
 * Chiave header per il filtro generare riguardo le
 * entità di cui l'utente è referente amministrativo.
 */
export const adminReferentFilterHeader = 'x-show-only-referent';
